import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  passphraseSet: boolean;
  hasAivisKey: boolean;
  hasClaudeKey: boolean;
  hasKieKey: boolean;

  setPassphraseSet: (v: boolean) => void;
  setHasKey: (provider: 'aivis' | 'claude' | 'kie', v: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      passphraseSet: false,
      hasAivisKey: false,
      hasClaudeKey: false,
      hasKieKey: false,

      setPassphraseSet: (v) => set({ passphraseSet: v }),
      setHasKey: (provider, v) => {
        if (provider === 'aivis') set({ hasAivisKey: v });
        if (provider === 'claude') set({ hasClaudeKey: v });
        if (provider === 'kie') set({ hasKieKey: v });
      },
    }),
    { name: 'vg-settings' },
  ),
);
